/// <reference lib="dom" />
import IMask, { InputMask } from 'imask'

interface HTMLInputElementWithMask extends HTMLInputElement {
  _maskInstance?: InputMask<any>
}

export default {
  mounted(el: HTMLInputElementWithMask) {
    // const mask = [
    //   // { mask: '00-AA-00' }, // Old format: 12-AB-34
    //   // { mask: 'AA-00-AA' }  // New format: AB-12-CD
    //   { mask: /^[0-9A-Z]{0,2}[0-9A-Z]{0,2}[0-9A-Z]{0,2}$/i }
    //   //{ mask: /^[0-9a-f]{0,2}-|[0-9a-f]{0,2}-|[0-9a-f]{0,2}$/i }
    //   //{mask: /^(?:[A-Z]{2}-\d{2}-\d{2}|\d{2}-\d{2}-[A-Z]{2}|\d{2}-[A-Z]{2}-\d{2}|[A-Z]{2}-\d{2}-[A-Z]{2})$/i}
    // ]

    const maskInstance = IMask(el, {
  mask: [
    '-00-00',
    // '00-00-AA',
    // '00-AA-00',
    // 'AA-00-AA'
  ],
  blocks: {
    L: { mask: /[A-Z]/ },
    0: { mask: /\d/ }
  },
  prepare: (str) => str.toUpperCase()
});

    // Listen for mask changes and sync with Vue
    maskInstance.on('accept', () => {
      // Dispatch input event so Vue reactivity works
      el.dispatchEvent(new Event('input', { bubbles: true }))
    })

    maskInstance.on('complete', () => {
      el.dispatchEvent(new Event('input', { bubbles: true }))
    })

    el._maskInstance = maskInstance
  },

  unmounted(el: HTMLInputElementWithMask) {
    if (el._maskInstance) {
      el._maskInstance.destroy()
      delete el._maskInstance
    }
  }
}